var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n              Колонки\n            ")]
                      ),
                      _vm._v(" "),
                      _vm.canEditRecruitJobPostings()
                        ? _c(
                            "b-btn",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(null, false)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n              Новая\n            ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filters-drawer",
        {
          attrs: {
            query: _vm.filters.query,
            "is-busy": _vm.isBusy,
            "filter-tags": _vm.activeFilterTags
          },
          on: {
            "update:query": function($event) {
              return _vm.$set(_vm.filters, "query", $event)
            },
            "remove-tag": _vm.removeFilterTag,
            submit: _vm.onSearch,
            clear: _vm.onClearFilters
          }
        },
        [
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Объявления")
              ]),
              _vm._v(" "),
              _c("recruit-job-posting-select", {
                ref: "recruit_job_posting_select",
                attrs: { title: "id объявления" },
                on: { onSelect: _vm.onSelectJobPosting }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Ответственные")
              ]),
              _vm._v(" "),
              _c("user-multi-select", {
                ref: "user_multi_select_assigned",
                attrs: {
                  id: "user-multi-select-assigned",
                  title: "Ответственные"
                },
                on: { onSelect: _vm.onSelectUserAssigned }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewMode === "table"
        ? _c("b-table", {
            ref: "job_posting_responses",
            staticClass: "mb-0 text-small",
            attrs: {
              id: "job-posting-responses",
              selectable: "",
              "select-mode": "single",
              selectedVariant: "success",
              striped: "",
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.renderedFields,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "no-local-sorting": "",
              "sticky-header": "",
              "head-variant": "light"
            },
            on: {
              "update:busy": function($event) {
                _vm.isBusy = $event
              },
              "sort-changed": _vm.sortChanged,
              "row-dblclicked": _vm.onRowClicked
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-busy",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center text-success my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка")])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "cell(fits)",
                  fn: function(row) {
                    return [
                      row.item.fits
                        ? [
                            _c("font-awesome-icon", {
                              staticClass: "text-success",
                              attrs: { icon: "check-circle" }
                            })
                          ]
                        : [
                            _c("font-awesome-icon", {
                              staticClass: "text-danger",
                              attrs: { icon: "times-circle" }
                            })
                          ]
                    ]
                  }
                },
                {
                  key: "cell(recruit_task_id)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.showModalRecruitTask(
                                row.item.recruit_task_id
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.item.recruit_task_id) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(job_posting_id)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.showModalJobPosting(
                                row.item.job_posting_id
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.item.job_posting_id) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(id)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onRowClicked(row.item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(row.item.id) + "\n        "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(assigned)",
                  fn: function(row) {
                    return [
                      row.item.assigned
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getAssignedName(row.item.assigned)) +
                                "\n        "
                            )
                          ])
                        : _c(
                            "b-button",
                            {
                              staticClass: "py-0 px-2",
                              attrs: { size: "sm", variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.takeAssignment(row.item)
                                }
                              }
                            },
                            [_vm._v("\n          Взять\n        ")]
                          )
                    ]
                  }
                },
                {
                  key: "cell(status)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getStatusText(row.item.status)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "cell(start_date)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatTableDate(row.item.start_date)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-button-group",
                        [
                          _vm.canEditWorkers()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.v-info",
                                      modifiers: { hover: true, "v-info": true }
                                    }
                                  ],
                                  staticClass: "mr-1",
                                  attrs: {
                                    disabled: row.item.worker_id !== null,
                                    size: "sm",
                                    variant: "info",
                                    title: "Создать исполнителя из отклика"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showModalWorker(row.item)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "plus" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEditRecruitJobPostings()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.v-danger",
                                      modifiers: {
                                        hover: true,
                                        "v-danger": true
                                      }
                                    }
                                  ],
                                  attrs: {
                                    variant: "danger",
                                    size: "sm",
                                    title: "Удалить отклик"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onRemove(row)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "ban" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2226852162
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "jobPostingResponses_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("JobPostingResponse", {
        ref: "job_posting_response",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      }),
      _vm._v(" "),
      _c("recruit-task", {
        ref: "modal_recruit_task",
        attrs: { "is-integrated": true }
      }),
      _vm._v(" "),
      _c("RecruitJobPosting", { ref: "modal_recruit_job_posting" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_worker",
          attrs: {
            "body-class": "p-0",
            title: "Создание нового исполнителя",
            size: "xl"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                return [
                  _c(
                    "div",
                    { staticClass: "justify-content-end m-0 p-0" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { size: "sm", variant: "secondary" },
                          on: {
                            click: function($event) {
                              return _vm.onModalWorkerClosed()
                            }
                          }
                        },
                        [_vm._v("Отмена")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmitModalWorker()
                            }
                          }
                        },
                        [_vm._v("Сохранить")]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("Worker", {
            ref: "worker_component",
            attrs: { "is-modal": true, "response-id": _vm.responseId },
            on: {
              refresh: _vm.onWorkerSaved,
              "close-modal": _vm.onModalWorkerClosed
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56e0bf72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e0bf72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/JobPostingResponses.vue
// module id = null
// module chunks = 